import React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import icon from "../userguidemc02/icon.jpg";
import advs from "../userguidemc02/LTSMC02.png";
import { Button, Container } from 'reactstrap';
import axios from "axios";
import {SET_LOADING, CLEAR_LOADING, setMessage, setError } from "../../actions/utils";
import { Checkbox, Show } from '../../components';
import messages from '../../i18n/messages';

export const UserGuideMC02 = ({ href, username, confirmMC02Doc, checkConfirmMC02Doc, bank }) => {
    console.log('UserGuideMC02: username = ' + username + ', bank = ' + bank);
    const [clickConfirm, setClickConfirm] = React.useState(false);
    const [isConfirmMC02Doc, setIsConfirmMC02Doc] = React.useState(false);
    const [confirmMC02Date, setConfirmMC02Date] = React.useState();
        
    React.useMemo(() => {
    if (!_.isEmpty(username)) {
        checkConfirmMC02Doc(username).then((res) => {
            console.dir(res);
            console.log(res?.confirm == 'YES');
            if (res?.confirm == 'YES') {
                setIsConfirmMC02Doc(true);                
                setConfirmMC02Date(res?.confirmDate);
            }
        });        
    }
    
    }, [username, isConfirmMC02Doc, confirmMC02Date]);

    return (
        <Container fluid className='config-list mt-3'>
        <div className='container'>
            <br/>
            <center>
                <img src={advs} alt='advertisement' style={{
                    width: '90%'
                }}/>
            </center>
            <br/><br/><br/>
            <center>
               <span>
                <a href={href} target='_blank'>
                  <b>
                    Xem chi tiết tài liệu đào tạo FWD Bảo hiểm sức khỏe trực tuyến
                  </b>
                </a>
               </span>
                <Show condition={!isConfirmMC02Doc}>
                    <br/><br/><br/>
                    <table style={{ verticalAlign:"top;" }}>
                    <tr>
                        <th>
                        <input
                            name='seqCheck'
                            type='checkbox'
                            value='YES'
                            onChange={(e) => {
                                if (clickConfirm) { 
                                    setClickConfirm(false); 
                                } else { 
                                    setClickConfirm(true); 
                                }
                            }}
                            
                            checked={clickConfirm}
                            className='custom-checkbox'
                        />
                        </th>
                        <th>&nbsp;Tôi cam kết rằng tôi đã đọc và hiểu rõ toàn bộ tài liệu bao gồm quyền lợi sản phẩm, quy định nghiệp vụ, điều khoản loại trừ, và quy trình tham gia
                        </th>
                    </tr>
                    </table>
                    <br/><br/>

                    <Button type='submit' disabled={!clickConfirm}
                        onClick={() => confirmMC02Doc(username).then((res) => { if (res?.seq) setIsConfirmMC02Doc(true); })}>
                        XÁC NHẬN
                    </Button>   
                </Show>          
                <Show condition={isConfirmMC02Doc}>
                    <br/><br/><br/>
                    <p>Đã xác nhận vào lúc: <b>{confirmMC02Date}</b></p>
                    <br/><br/>
                </Show>  
            </center>
        </div>
        </Container>
    );
};

const confirmMC02Doc = (username) => async (dispatch) => {
    try {
        dispatch({ type: SET_LOADING });
        console.log('Begin saving confirmation: ' + username);
        let dataInput = { agentCode: username };
        let cResponse = await axios.post(`/api/read-mc02-document`, dataInput);
        setMessage('Đã xác nhận thành công');        
        return cResponse?.data;
    } catch (error) {
        setMessage('Không thể xác nhận, vui lòng thử lại sau');
    } finally {        
        dispatch({ type: CLEAR_LOADING });
    }
    return {};
};

const checkConfirmMC02Doc = (username) => async (dispatch) => {
    
    try {
        dispatch({ type: SET_LOADING });
        console.log('Begin checking confirmation: ' + username);
        let dataInput = { agentCode: username };
        let cResponse = await axios.post(`/api/check-mc02-document`, dataInput);    
        return cResponse?.data;        
    } catch (error) {
        console.err('Error occurs whilst checking confirmation: ' + username);   
    } finally {        
        dispatch({ type: CLEAR_LOADING });
    }
    return {};
};

const mapStateToProps = (state) => {
    const isFSC = state?.auth?.isFSC;
    let href = isFSC ? `${process.env.PUBLIC_URL}/MC0207032025.pdf` : `${process.env.PUBLIC_URL}/MC0207032025.pdf`;
    let username = state?.auth?.loginUsername;
    let bank = state?.lookup?.bank;
    return { href, username, bank };
};
const mapDispatchToProps = { confirmMC02Doc, checkConfirmMC02Doc };
export default connect(mapStateToProps, mapDispatchToProps)(UserGuideMC02);
